import React, { useEffect, useState } from 'react';
import { getLocalRecentProducts } from '../../../Utils/ProductUtils';
import UserAlsoBought from '../UserAlsoBought';
import ProductContainer from '../../NewStoreHomeWeb/CategoryProductFilter/ProductContainer';
import { getGeneralItemByItemId } from '../../../datafetchers/Store';

function LocalSimilarProducts(props) {
  const [localRecentProducts, setLocalRecentProducts] = useState([]);
  const [generalItems, setGeneralItems] = useState([]);
  const productId = props.productId;

  const makeIntroOfferItem = async () => {
    const INTRO_OFFER_ITEM_ID = 6094;
    const data = await getGeneralItemByItemId(INTRO_OFFER_ITEM_ID);
    if (data) {
      setGeneralItems([data]);
    }
  };

  useEffect(() => {
    const recent_data = getLocalRecentProducts(productId);
    setLocalRecentProducts(recent_data);
    makeIntroOfferItem();
  }, [productId]);

  return (
    <>
      {localRecentProducts?.length > 0 ? (
        <UserAlsoBought
          title={`RECENTLY VIEWED PRODUCTS`}
          setChangeCartCount={props.setChangeCartCount}
          data={localRecentProducts}
        />
      ) : null}
      {generalItems?.length > 0 &&
        generalItems.map((element, index) => (
          <ProductContainer
            key={index}
            data={element}
            isForJoyfulPage={true}
            setChangeCartCount={props.setChangeCartCount}
            fitHeadingImage={true}
            increasedWidth={true}
          />
        ))}
    </>
  );
}

export default LocalSimilarProducts;
